import React, { Component } from 'react';
import { connect } from  'react-redux';
import { addToCart } from './Actions/cartActions';
import "./Items.css"
class Home extends Component{
    handleClick = (id)=>{
        this.props.addToCart(id);
        alert("item has been added to cart"); 
    }
    render(){
        let itemList = this.props.items.map(item=>{
            return(
                <div className="box">
                <div className="card" key={item.id}>
                       
                        <div className="card-image">
                            <img src={item.img} alt={item.title}/></div><br/>
                            <div className="subtext">   
                            <span className="card-title">{item.title}</span>    
                            <span className="button" to="/"><button onClick={()=>{this.handleClick(item.id)}} className="material-icons">+</button></span>
                        </div>

                        <div className="card-content">
                        
                            <p>{item.desc}</p>
                            <p><b>Price: {item.price}$</b></p>
                        </div>
                 </div>
                 </div>
            )
        })
        return(
            
            <div className="container">
                
               <h3><br/></h3>
               <h3>Our Games:</h3> 
                   <div className="box">
                    {itemList}
                </div>
                
            </div>
            
        )
       
    }
        
} 
const mapStateToProps = (state)=>{
    return {
      items: state.items
    }
  }
  const mapDispatchToProps= (dispatch)=>{
    
    return{
        addToCart: (id)=>{dispatch(addToCart(id))}
    }
} 


export default connect(mapStateToProps,mapDispatchToProps)(Home);